import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {LoginRoutingModule} from './login-routing.module';
import {LoginComponent} from './login.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';
import {ReactiveFormsModule} from '@angular/forms';
import {FormFieldModule} from "@app/presentation/components/form-field/form-field.module";
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {AppBarModule} from "@app/presentation/components/app-bar/app-bar.module";
import {DialogsModule} from "@app2u/dialogs";
import {LocalizeRouterModule} from "@gilsdav/ngx-translate-router";

@NgModule({
    declarations: [LoginComponent],
    imports: [
        CommonModule,
        LoginRoutingModule,
        MatInputModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatButtonModule,
        MatSnackBarModule,
        MatIconModule,
        TranslateModule,
        FormFieldModule,
        ButtonModule,
        AppBarModule,
        DialogsModule,
        LocalizeRouterModule,
    ],
    exports: [
        LoginComponent
    ],
})
export class LoginModule {}
